import {WebGlConfigType} from "../global";

const getHostConfig = (host: string): WebGlConfigType => {
  if (window.GameEnvironment.hosts.hasOwnProperty(host)) {
    return window.GameEnvironment.hosts[host];
  }
  throw new Error("No configuration found for host " + host);
};

const getConfigByHost = (host: string) => {
  const hostConfig = getHostConfig(host);
  const envName = window.GameEnvironment.config.webgl_environment_name;

  return {
    ...hostConfig,
    auth:
      envName.toLowerCase() === "prod" ? hostConfig.gandalf_auth?.prod_config : hostConfig.gandalf_auth?.gamma_config,
    event_auth:
      envName.toLowerCase() === "prod" ? hostConfig.event_gandalf_auth?.prod_config : hostConfig.event_gandalf_auth?.gamma_config,
  };
};

const getEnvConfig = () => {
  const location = window.location;
  let host = location.host;

  return getConfigByHost(host);
};

export default getEnvConfig;
